

















































import Vue, { PropOptions } from 'vue';
import { cloneDeep } from 'lodash';
import { VueEditor } from 'vue2-editor';
import UploadProductImage from '@/web/components/products/UploadProductImage.vue';

interface ProductSalesPageTestimonialItemProps {
  testimonial: PropOptions;
}
interface ProductSalesPageTestimonialItemState {
  testimonialL: CreateUpdateSalesPageTestimonialRequest | null;
  expanded: boolean;
}

export default Vue.extend({
  name: 'ProductSalesPageTestimonialItem',
  components: { VueEditor, UploadProductImage },
  props: {
    testimonial: {
      type: Object as () => ProductSalesPageTestimonialResponse,
    },
  } as ProductSalesPageTestimonialItemProps,
  data(): ProductSalesPageTestimonialItemState {
    return {
      testimonialL: null,
      expanded: false,
    };
  },
  mounted() {
    this.expanded = !this.testimonial.name && !this.testimonial.testimonial;
  },
  computed: {
    title(): string {
      if (this.testimonialL) {
        if (this.testimonialL.id && !this.testimonialL.name) {
          return `${this.$t('PRODUCTS.LABELS.TESTIMONIAL')}`;
        } else {
          return (
            this.testimonial.name ??
            (this.$t('PRODUCTS.LABELS.TESTIMONIAL') as string)
          );
        }
      }
      return this.$t('PRODUCTS.LABELS.TESTIMONIAL') as string;
    },
  },
  watch: {
    testimonial: {
      handler(value: ProductSalesPageTestimonialResponse) {
        this.testimonialL = cloneDeep(this.testimonial);
      },
      immediate: true,
    },
  },
  methods: {
    submit(): void {
      this.expanded = false;
      if (this.testimonialL?.photo_obj) {
        this.testimonialL.photo = this.testimonialL.photo_obj?.id as number;
      }
      this.$emit('submit', this.testimonialL);
    },
    remove(): void {
      this.$emit('remove', this.testimonialL);
    },
    toggleExpand(): void {
      this.expanded = !this.expanded;
      this.testimonialL = cloneDeep(this.testimonialL);
    },
  },
});
